import { Platform } from 'react-native';

/**
 * "Tap" on a phone, "Click" in a browser. For instructions that name the
 * gesture ("Tap to upgrade"); on the phone the value never changes.
 */
export const TAP = Platform.OS === 'web' ? 'Click' : 'Tap';
